export default __webpack_public_path__ + "static/media/nomadN.40bb1143.webp";